import mixpanel from 'mixpanel-browser';

// const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined;

// Hardcoded for now, will be replaced with the actual token from the environment variables
const MIXPANEL_TOKEN = 'f8d1dc081e6941f857026fd1de3193bc';

export const initAnalytics = () => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: false,
    persistence: 'localStorage',
  });
};

export const track = (event: string, properties?: Record<string, unknown>) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.track(event, properties);
};

export const identifyUser = (userId: string, traits?: Record<string, unknown>) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.identify(userId);
  if (traits) mixpanel.people.set(traits);
};

export const resetAnalytics = () => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.reset();
};
